<template>
<div class="dropdown-pane"
  :class="[droppaneClass, { 'is-open': isOpen }]"
  :style="droppaneStyle"
  id="grauDropDown">
    <ul class="drop" :class="dropClass" 
        v-show="show">
        <slot></slot>
    </ul>
</div>
</template>

<script>
  export default {
    props:["isOpen","show","droppaneStyle","droppaneClass","dropClass"]
  }
</script>

<style scoped>
.dropdown-pane {
  width: 100%;
  padding: 0;
}

.drop.nopaddingtop{
  padding-top: 0;
}

.drop {
  list-style-type: none;
  margin-bottom: 0;
  max-height: 450px;
  overflow-y: scroll;
}

.drop::-webkit-scrollbar {
  opacity: 0;
  width: 0;
}

@media (max-width: 1200px) {
  /*.drop {
    padding-top: 15px;
    padding-bottom: 20px;
  } */ 
}

@media (max-width: 767px) {
  .drop {
    padding-top: 0;
    padding-bottom: 25px;
  }
}
</style>